import api from "../../services/api";

const settingsCache = new Map();
const settingsAllCache = new Map();

const useCompanySettings = () => {
    const isUnauthorized = (error) =>
        error?.response?.status === 401 || error?.response?.status === 403;

    const getAll = async (companyId) => {
        if (settingsAllCache.has(companyId)) {
            return settingsAllCache.get(companyId);
        }
        const { data } = await api.request({
            url: `/companySettings/${companyId}`,
            method: 'GET'
        });
        settingsAllCache.set(companyId, data);
        return data;
    }

    const get = async (params) => {
        if (!localStorage.getItem("token")) return {};
        const cacheKey = JSON.stringify(params || {});
        if (settingsCache.has(cacheKey)) {
            return settingsCache.get(cacheKey);
        }
        try {
            const { data } = await api.request({
                url: '/companySettingOne',
                method: 'GET',
                params
            });
            settingsCache.set(cacheKey, data);
            return data;
        } catch (error) {
            if (isUnauthorized(error)) return {};
            throw error;
        }
    } 

    const update = async (data) => {
        settingsCache.clear();
        settingsAllCache.clear();
        const { data: responseData } = await api.request({
            url: '/companySettings',
            method: 'PUT',
            data
        });
        return responseData;
    }

    return {
        getAll,
        get,
        update
    }
}

export default useCompanySettings;
